import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user_details");
    if (stored) {
      try {
        const u = JSON.parse(stored);
        return {
          id: u.id,
          name: u.display_name || u.email || "Admin",
          email: u.email || "",
          role: u.role || "admin",
          avatar: u.display_name
            ? u.display_name.split(" ").map((n) => n[0]).join("")
            : "A",
        };
      } catch (e) {
        return null;
      }
    }
    return null;
  });

  const login = useCallback((userData) => {
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("tokens");
    localStorage.removeItem("refresh tokens");
    localStorage.removeItem("expires in");
    localStorage.removeItem("refresh expires");
    localStorage.removeItem("user_details");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
